import { on, createReducer } from '@ngrx/store';
import * as fromActions from '../actions/router-history.actions';

export interface RouterHistory {
  prevUrl: string;
  currentUrl: string;
}

export const initialState: RouterHistory = {
  prevUrl: '',
  currentUrl: '',
};

export const reducer = createReducer(
  initialState,
  on(fromActions.SetPrevUrl, (state: RouterHistory, { url }) => {
    const prevUrl = state.currentUrl;
    const currentUrl = url;
    if (currentUrl.includes('delivery') && prevUrl.includes('delivery')) {
      return { ...state };
    }

    return { ...state, prevUrl, currentUrl };
  }),
);

export const selectPrevUrl = (state: RouterHistory) => state.prevUrl;
